export const CANVAS_NODE_BORDER_WIDTH = 2;
export const NODE_TRACKER_WIDTH = 12;
export const CANVAS_NODE_PADDING = 0;
export const DEFAULT_OUTPUT_LIMIT = 1;
